import React, { PropTypes } from 'react';

import Slider from 'react-slick';

import Screen, { MaxResolutions } from '../../Shared/Helpers/Screen';
import './Carousel.scss';
import BusyIndicator from '../../Shared/Helpers/BusyIndicator/BusyIndicator';

export default class Carousel extends React.Component {
    render() {
        let slideOnMobile = Screen.isMobile && !!this.props.slideOnMobile;
        let isSlickOnMobile = this.props.columnsAmount !== 1 && slideOnMobile;

        let settings = {
            slidesToShow: slideOnMobile ? 1 : this.props.columnsAmount,
            slidesToScroll: slideOnMobile ? 1 : this.props.columnsAmount,
            infinite: false,
            nextArrow: <NextArrow />,
            prevArrow: <PrevArrow />,
            responsive: [
                {
                    breakpoint: MaxResolutions.Mobile,
                    settings: isSlickOnMobile ? '' : 'unslick'
                },
                {
                    breakpoint: 100000,
                    settings: this.props.columnsAmount === 1 ? 'unslick' : ''
                }
            ]
        }

        let view = null;

        if (!this.props.children || !this.props.children.length) {
            view = <BusyIndicator />
        } else {
            view = (
                <Slider {...settings}>
                    {this.props.children}
                </Slider>);
        }

        return (
            <div className="carousel">
                {view}
            </div>
        );
    }
}

Carousel.propTypes = {
    columnsAmount: PropTypes.number.isRequired
};

let PrevArrow = (props) => {
    return (<img className={props.className}
        src="/images/shared/Carousel/prev-arrow.svg"
        alt="prev-arrow"
        onClick={props.onClick} />);
};

let NextArrow = (props) => {
    return (
        <img className={props.className}
            src="/images/shared/Carousel/next-arrow.svg"
            alt="next-arrow"
            onClick={props.onClick} />);
};


// WEBPACK FOOTER //
// ./Src/Components/Carousel/Carousel.jsx